import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { UsuarioActual } from '@/views/a-login/login-controlador';
import router from '@/__env/router.index';
import { Utiles } from '@/__env/pluggins/event-bus';
import { Turnero } from '@/__env/lib/Turnero';
import { Wait } from '@/__env/ext';

export class ControladorTunero
{
    public get Usuario() { return UsuarioActual; }
    public Turnero: Turnero = new Turnero();
    public Puesto: number = 0;

    public readonly Vista = new Vista();
    public Iniciado: boolean = false;
    public async Iniciar()
    {
        this.Turnero = await Turnero.create( 1 );
        this.Turnero.onActualizar.subscribe( () => { this._onActualizar.dispatch(); } );
        this.Vista.Estado = 'iniciado';
        this.Vista.Modo = 'turnos';
        this.Vista.SubModo = 'puesto';
        this.Iniciado = true;
    }

    private _onActualizar = new SignalDispatcher();
    public get onActualizar() { return this._onActualizar.asEvent(); }

    public async SeleccionarPuesto( x: number )
    {
        this.Puesto = x;
        this.Vista.SubModo = 'turnos';
    }

    public async Siguiente()
    {
        await this.Turnero.Siguiente( this.Puesto );
    }

    public async Reiniciar( x?: number )
    {
        if ( x )
        {
            if ( await Utiles.Mensajes.SiNo( 'Reiniciar turnero', '¿Está seguro de reiniciar el turnero? El contador comenzará en ' + x + '.' ) )
            {
                await this.Turnero.Reiniciar( x );
            }
        }
        else
        {
            if ( await Utiles.Mensajes.SiNo( 'Reiniciar turnero', '¿Está seguro de reiniciar el turnero? El contador volverá a cero.' ) )
            {
                await this.Turnero.Reiniciar();
            }
        }

    }

}

type Opcion = {
    Icono?: string,
    Titulo?: string,
    Subtitulo?: string,
    Modo?: string,
    Resaltado?: boolean,
    Oculto?: boolean,
    Accion?: Function,
    Tipo: 'opcion' | 'titulo',
};




class Vista
{
    public readonly Titulo: string = 'Turnero';

    protected modo: string = 'creados';
    get Modo(): string { return this.modo; }
    set Modo( m: string )
    {
        this.modo = m;
        this._onModo.dispatch();
        this.query = {};
        this.query['m'] = this.modo;
        Utiles.setQuery( this.query );
    }
    private _onModo = new SignalDispatcher();
    public get onModo() { return this._onModo.asEvent(); }

    protected query: Record<string, string> = {};
    public set Query( x: Record<string, string> )
    {
        this.query = x;
        this.query['m'] = this.modo;
        this.query['x'] = this.submodo;
        Utiles.setQuery( this.query );
    }
    private _onEditarQuery = new SimpleEventDispatcher<string>();
    public get onEditarQuery() { return this._onEditarQuery.asEvent(); }

    protected submodo: string = 'puesto';
    get SubModo(): string { return this.submodo; }
    set SubModo( m: string )
    {
        this.submodo = m;
        this.query['x'] = this.submodo;
        Utiles.setQuery( this.query );
        this._onSubModo.dispatch();
    }
    private _onSubModo = new SignalDispatcher();
    public get onSubModo() { return this._onSubModo.asEvent(); }

    protected estado: string = 'cargando';
    get Estado(): string { return this.estado; }
    set Estado( m: string ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }
}




